export const CSV_ISSUE_LIMIT = 300;
